import React, { useEffect, useState } from 'react'
import { Button, Card, Form, Input, InputNumber, message, Modal, Spin, Select, Skeleton, Typography, ConfigProvider } from "antd";
import { useSelector } from "react-redux";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../../Common/APIConstants";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
const { Title } = Typography;


const GroupConfig = () => {
  const mode = useSelector((state) => state.darkMode);
  const { isdarkMode } = mode;
  const [open, setOpen] = useState(false);
  const [groupname, setGroupname] = useState([]);
  const { makeRequest } = useStoreUpdaterWithAPI();
  const [groupID, setGroupId] = useState();
  const [loading, setLoading] = useState(true)
  const [rowData, setRowData] = useState([])
  const [showGrid, setShowGrid] = useState(false);
  setTimeout(() => {
    setLoading(false)
  }, 2000)
  const handleOk = () => {
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleAddPopup = () => {
    console.log("pop open");
    setOpen(true);
  };

  useEffect(() => {
    makeRequest({
      type: APIConstants.POST,
      url: `${APIConstants.ELECTRICAL_GROUP_NAME}`,
    }).then((res) => {
      // if (res) {
      //   const filteredGroupnames = res.filter(
      //     (group) => group.groupID === 6 || group.groupID === 7
      //   );
      //   setGroupname(filteredGroupnames);
      // }
      if(res){
        setGroupname(res)
      }
    });
  }, [])



  const onFinish = (values) => {
    console.log('Form values:', values);

    if (groupID) {
      makeRequest({
        type: APIConstants.POST,
        url: `${APIConstants.ELCTRICAL_METER_DETAILS}?GroupId=${groupID}`,
      }).then((res) => {
        console.log("Meter Details:", res);
        if (res && res.length > 0) {
          setShowGrid(true)
          setRowData(res)
        } else {
          setRowData([])
          setShowGrid(false)
        }
      }).catch((err) => {
        console.error("Error fetching meter details", err);
      });
    } else {
      console.error("Something went wrong")
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Form validation failed:', errorInfo);

  };

  const columnDefs = [
    {
      headerName: 'S.No',
      valueGetter: (params) => {
        return params.node.rowIndex + 1;
      },
      headerStyle: { fontWeight: '800' }
    },
    {
      headerName: 'GROUP NAME', field: 'groupName', headerStyle: { fontWeight: '800', textAlign: 'center' },
      headerClass: 'ag-header-cell-centered'
    },
    {
      headerName: 'SUB GROUP NAME', field: 'subGroupName',
      headerStyle: { fontWeight: '800', textAlign: 'center' },
      headerClass: 'ag-header-cell-centered'
    },

    {
      headerName: 'CONVERTER NAME', field: 'sitename', headerStyle: { fontWeight: '800', textAlign: 'center' },
      headerClass: 'ag-header-cell-centered'
    },
    {
      headerName: 'CONVERTER ID', field: 'siteid', headerStyle: { fontWeight: '800', textAlign: 'center' },
      headerClass: 'ag-header-cell-centered'
    },
    // {
    //   headerName: 'METER TYPE', field: 'metertype', headerStyle: { fontWeight: '800', textAlign: 'center' },
    //   headerClass: 'ag-header-cell-centered'
    // },
    {
      headerName: 'METER ID', field: 'autoID', headerStyle: { fontWeight: '800', textAlign: 'center' },
      headerClass: 'ag-header-cell-centered'
    },
    {
      headerName: 'METER NAME', field: 'metername', headerStyle: { fontWeight: '800', textAlign: 'center' },
      headerClass: 'ag-header-cell-centered'
    },
    // {
    //   headerName: 'CONSUMPTION', field: 'consumption', headerStyle: { fontWeight: '800', textAlign: 'center' },
    //   headerClass: 'ag-header-cell-centered'
    // },
  ]
  const color = useSelector((state) => state.ThemeChange);
  console.log(color)

  return (
    loading ? (
      <>
        <Skeleton active paragraph={{ rows: 6 }} />
      </>
    ) : (
      <div>
         <h4 className={`text-left text-[20px] mb-5 dark ${isdarkMode ? 'darkfont' : 'whitemode'}`}>GROUP CONFIG</h4>
        <Card
          className={`w-full h-auto dark ${!isdarkMode ? "bg-slate-50 border-0" : "bg-slate-900"} `}
        >
          <div className='flex justify-between'>
            <div className='flex gap-10 justify-center items-center'>
              <Form
                layout="inline"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
              >
                  <label className={` mr-3 ${isdarkMode ? 'darkfont' : 'whitemode'}`}>Group Name</label>
                <Form.Item
                  // label=" "
                  name="groupname"
                  className={isdarkMode ? 'darkfont' : 'whitemode'}
                  rules={[{ required: true, message: "Please select Group Name!" }]}
                >
               {/* <label className={` mr-3 ${isdarkMode ? 'darkfont' : 'whitemode'}`}>Group Name</label> */}
                  <Select 
                    placeholder="Select Group Name"
                    onChange={(value) => setGroupId(value)}
                    style={{ width: "200px" }}
                    dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}
                    className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'}`}
                  >
                    {groupname.map((group) => (
                      <Select.Option key={group.groupID} value={group.groupID}>
                        {group.department}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                      <Button  type= {isdarkMode? "":'primary'} htmlType="submit" className=" mb-2">
                  Search
                </Button>
               
              </Form>
            </div>
                      <Button
            type= {isdarkMode? "":'primary'}
            onClick={handleAddPopup}
            className=" mb-2"
          >
            Add Group Config
          </Button>

            <GroupPopup
              handleOk={handleOk}
              handleCancel={handleCancel}
              open={open}
            />
          </div>
        </Card>
        {
          rowData.length == 0 && (
            <div className={`dark ${isdarkMode ? 'darkfont' : 'whitemode'} text-center text-xl font-[400] mt-28`} >No Data is Available</div>
          )
        }
        {showGrid && (
          <Card className={`w-full h-auto dark ${!isdarkMode ? "bg-slate-50 border-0" : "bg-slate-900"} mt-10`}>
            <p className={`font-[600] text-[18px] dark ${isdarkMode ? 'darkfont' : 'whitemode'}`}>GRID VIEW</p>
            <div className={`${isdarkMode ? "ag-theme-alpine-dark" : "ag-theme-alpine"}`} 
              style={{
                '--ag-header-background-color': color.themeConfig.colorPrimary, 
                '--ag-header-foreground-color': '#fff', 
                height: "80vh", width: "100%", overflowY: "auto" 
              }}>
              <AgGridReact
                columnDefs={columnDefs}
                rowData={rowData}
                domLayout="autoHeight"
              />
            </div>
          </Card>
        )
        }
      </div>
    )
  );

}

export default GroupConfig;


const GroupPopup = ({
  handleOk,
  handleCancel,
  open,
  loading,
  handleNotification,
  refetch,
  setRefetch,
}) => {
  const mode = useSelector((state) => state.darkMode);
  const { isdarkMode } = mode;
  const { makeRequest } = useStoreUpdaterWithAPI();
  const [groupname, setGroupname] = useState([]);
  const [subGroup, setSubGroup] = useState([]);
  const [groupID, setGroupId] = useState();
  const [consumptionDetail, setConsumptionDetails] = useState([]);
  const [getFlowConverterResData, setgetFlowConverterResData] = useState([]);
  const [nsGetFlowConverterResData, setnsGetFlowConverterResData] = useState([]);
  const [converterGroupId, setConverterGroupId] = useState();
  const [selectedMeterIds, setSelectedMeterIds] = useState([]);
  const [form] = Form.useForm();

  useEffect(() => {
    //  Group Name
    makeRequest({
      type: APIConstants.POST,
      url: `${APIConstants.ELECTRICAL_GROUP_NAME}`,
    }).then((res) => {
      // if (res) {
      //   const filteredGroupnames = res.filter(
      //     (group) => group.groupID === 6 || group.groupID === 7
      //   );
      //   setGroupname(filteredGroupnames);
      // }
      if(res){
        setGroupname(res)
      }
    });

    //  Converter Data
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_FLOW_CONVERTER_DETAILS}`,
    }).then((res) => {
      setgetFlowConverterResData(res);
    });

    //  Consumption Details
    makeRequest({
      type: APIConstants.POST,
      url: `${APIConstants.ELECTRICAL_CONSUMPTION_DETAILS}`,
    }).then((res) => {
      setConsumptionDetails(res);
    });
  }, []);

  // Sub group
  useEffect(() => {
    if (groupID !== undefined) {
      makeRequest({
        type: APIConstants.POST,
        url: `${APIConstants.ELECTRICAL_SUB_GROUPDETAILS}?GroupId=${groupID}`,
      }).then((res) => {
        setSubGroup(res);
      }).catch((error) => {
        console.error("Error fetching sub groups:", error);
        setSubGroup([]);
      });
    }
  }, [groupID]);

  // Converter
  useEffect(() => {
    if (converterGroupId) {
      makeRequest({
        type: APIConstants.GET,
        url: `${APIConstants.ELECTRICAL_METERS_DETAILS}?ConverterID=${converterGroupId}`,
      }).then((res) => {
        setnsGetFlowConverterResData(res);
      });
    }
  }, [converterGroupId]);

  const handleMeterChange = (selectedKeys) => {
    const selectedMeters = selectedKeys.map((selectedKey) => {
      const meter = nsGetFlowConverterResData.find((meter) => meter.metername === selectedKey);
      return meter ? { meterId: meter.meterid, meterName: meter.metername } : null;
    }).filter(Boolean);

    setSelectedMeterIds(selectedMeters);
  };

  const onFinish = (values) => {

    const selectedGroup = groupname.find(group => group.department === values.groupname);
    const selectedSubGroup = subGroup.find(subgroup => subgroup.subGroupName === values.subgroup);
    const selectedConverter = getFlowConverterResData.find(converter => converter.sitE_ID === values.convertername);
    const selectedConsumption = consumptionDetail.find(consumption => consumption.parametername === values.consumption);


    const meterIdsAndNames = selectedMeterIds
      .map(({ meterId, meterName }) => `${meterId}$${meterName}`)
      .join(",");
    const meterTypeValue = values.metertype === "type1";


    const transformedData = {
      siteID: selectedConverter.sitE_ID,
      departmentID: selectedGroup.groupID,
      meterIdsandMeterName: meterIdsAndNames,
      department: selectedGroup.department,
      siteName: selectedConverter.sitename,
      meterType: meterTypeValue,
      subGroupID: selectedSubGroup.subGroupID,
      consumption: selectedConsumption.parameterid,
    };


    console.log("Transformed Data to Submit:", transformedData);


    makeRequest({
      type: APIConstants.POST,
      url: `${APIConstants.ELECTRICAL_INSERT_GROUP_DETAILS}`,
      body: transformedData,
    })
      .then((res) => {
        console.log('API Response:', res);
        console.log('Transformed Data:', transformedData);
        message.success('Group Config saved successfully!');


        handleOk();
      })
      .catch((error) => {
        console.error('Error saving Group Config:', error);
      });
  };


  useEffect(() => {
    if (open) {
      form.resetFields();
    }
  }, [open, form]);
  
  const color = useSelector((state) => state.ThemeChange);
  console.log(color)

  return (
    <Modal
      open={open}
      // title={<div className={` ${isdarkMode ? "text-white" : "text-black"}`}>Add Group Config</div>} 
      onOk={handleOk}
      onCancel={handleCancel}
      footer={null}
      // className={`custom-modal ${isdarkMode ? "dark-modal" : "light-modal"}`}
      className={`custom-modal  ${isdarkMode ? " group-custom-modal-dark  group-custom-modal-header group-labels group-input group-select-input-background " : "whitemode"} `}
    >
       <div className="modal-header mb-2 px-4 py-3 rounded-t-lg" 
       style={{ backgroundColor: color.themeConfig.colorPrimary }}>
        <Title level={4} style={{ margin: 0, color: "white" }}>
          Add Group Config
        </Title>
      </div>

      {/* Form Content */}
      <div className="modal-body px-4 pb-3">
      <Form
        form={form}
        name="add-Group-Config"
        layout="horizontal"
        style={{
          maxWidth: 600,
        }}
        labelCol={{
          span: 8,
        }}
        labelAlign="left"
        onFinish={onFinish}
        className='p-3'
      >
        {/* Group Name */}
        <Form.Item
          label="Group Name"
          name="groupname"
          rules={[{ required: true, message: "Please select Group Name!" }]}
        >
          <Select
            placeholder="Select Group Name"
            dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}
            className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'} w-80 `}
            onChange={(value) => {
              const selectedGroup = groupname.find(group => group.department === value);
              if (selectedGroup) {
                setGroupId(selectedGroup.groupID);
              }
            }}
          >
            {groupname.map((group) => (
              <Select.Option key={group.groupID} value={group.department}>
                {group.department}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        {/* Sub Group */}
        <Form.Item
          label="Sub Group"
          name="subgroup"
          rules={[{ required: true, message: "Please select Sub Group!" }]}
        >
          <Select placeholder="Select Sub Group" 
          dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}
          className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'} w-80 `}>
            {subGroup &&
              subGroup.map((group) => (
                <Select.Option key={group.subGroupID} value={group.subGroupName}>
                  {group.subGroupName}
                </Select.Option>
              ))}
          </Select>
        </Form.Item>

        {/* Converter */}
        <Form.Item
          label="Converter Name"
          name="convertername"
          rules={[{ required: true, message: "Please select Converter Name!" }]}
        >
          <Select
            placeholder="Select Converter Name"
            onChange={(value) => setConverterGroupId(value)}
            dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}
            className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'} w-80 `}
          >
            {getFlowConverterResData &&
              getFlowConverterResData.map((val) => (
                <Select.Option key={val.sitE_ID} value={val.sitE_ID}>
                  {val.sitename}
                </Select.Option>
              ))}
          </Select>
        </Form.Item>

        {/* Consumption */}
        <Form.Item
          label="Consumption"
          name="consumption"
          rules={[{ required: true, message: "Please select Consumption!" }]}
        >
          <Select placeholder="Select Consumption"
          dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}
          className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'} w-80 `}>
            {consumptionDetail &&
              consumptionDetail.map((param) => (
                <Select.Option key={param.parameterid} value={param.parametername}>
                  {param.parametername}
                </Select.Option>
              ))}
          </Select>
        </Form.Item>

        {/* Meter Type */}
        <Form.Item
          label="Device Type"
          name="metertype"
          rules={[{ required: true, message: "Please select Device Type!" }]}
        >
          <Select placeholder="Select Device Type"
          dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}
          className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'} w-80 `}>
            <Select.Option value="type1">Plus</Select.Option>
            <Select.Option value="type2">Minus</Select.Option>
          </Select>
        </Form.Item>

        {/* TreeSelect for Meters */}
        <Form.Item
          label="Device"
          name="meters"
          rules={[{ required: true, message: "Please select Meters!" }]}
        >
          <Select
            mode="multiple"
            placeholder="Select Device"
            value={selectedMeterIds}
            onChange={handleMeterChange}
            optionLabelProp="label"
            dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}
            className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'} w-80 `}
          >
            {nsGetFlowConverterResData.map((meter) => (
              <Select.Option key={meter.meterid} value={meter.metername} label={meter.metername}>
                {meter.metername}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        {/* Footer Buttons */}
        <Form.Item
          wrapperCol={{
            offset: 16,
            span: 16,
          }}
        >
          <Button key="back" className="mr-3" onClick={handleCancel}>
            Cancel
          </Button>

          <Button htmlType="submit" type="primary" loading={loading}>
            Save
          </Button>
        </Form.Item>
      </Form>
      </div>
    </Modal>
  );
};


